// A one-line indirection over window.location, and the reason is testability.
//
// jsdom defines window.location as a non-configurable own accessor whose
// methods are themselves non-configurable and non-writable, so a test can
// neither replace the object nor spy on `replace`. react-scripts' Jest setup
// pinned an older jsdom where `delete window.location` still worked, which is
// how the tests were originally written.
//
// Routing the call through a module gives tests a seam they can mock, without
// changing what the application does.
export const redirectTo = (url) => {
  window.location.replace(url);
};
